export default __webpack_public_path__ + "static/media/1.08bbd804.jpg";